import { render } from "./listProducts.vue?vue&type=template&id=22cd96c8&scoped=true"
import script from "./listProducts.vue?vue&type=script&lang=js"
export * from "./listProducts.vue?vue&type=script&lang=js"

import "./listProducts.vue?vue&type=style&index=0&id=22cd96c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cd96c8"]])

export default __exports__